export const ON_ADMIN_LIST_SELECT = 'ON_ADMIN_LIST_SELECT';
export const ON_ADMIN_ROLE_SELECT = 'ON_ADMIN_ROLE_SELECT';
export const ON_ADMIN_ACTIVE_CHANGE = 'ON_ADMIN_ACTIVE_CHANGE';
export const ON_ADMIN_UPDATE = 'ON_ADMIN_UPDATE';
export const ON_ADMIN_DELETE = 'ON_ADMIN_DELETE';
export const ON_ADMIN_CREATE_UPDATE = 'ON_ADMIN_CREATE_UPDATE';
export const ON_ADMIN_CREATE_SUBMIT_ERROR = 'ON_ADMIN_CREATE_SUBMIT_ERROR';
export const ON_ADMIN_CREATE_SUBMIT_SUCCESS = 'ON_ADMIN_CREATE_SUBMIT_SUCCESS';
